var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":"点的大小"}},[_c('avue-slider',{model:{value:(_vm.main.activeOption.symbolSize),callback:function ($$v) {_vm.$set(_vm.main.activeOption, "symbolSize", $$v)},expression:"main.activeOption.symbolSize"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }